import { render, staticRenderFns } from "./movedLessonTeacherToDoDetails.vue?vue&type=template&id=7be674e2&scoped=true"
import script from "./movedLessonTeacherToDoDetails.vue?vue&type=script&lang=ts"
export * from "./movedLessonTeacherToDoDetails.vue?vue&type=script&lang=ts"
import style0 from "./movedLessonTeacherToDoDetails.vue?vue&type=style&index=0&id=7be674e2&prod&scoped=true&lang=css"
import style1 from "@/components/acquisitionList/ui/acquisitionViews.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "@/components/common/modern/modern.css?vue&type=style&index=2&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be674e2",
  null
  
)

export default component.exports